export const SINNGEBER_FAQ_URL = 'https://sinngeber.freshdesk.com/support/solutions';
